import { useMenu } from '../contexts/menu-context';
import ArticleEditMenu from "../../features/articles/components/article-edit-menu";

export const useMenuManager = () => {
  const { setMenuComponent, resetToMainMenu } = useMenu();

  const setArticleEditMenu = () => {
    setMenuComponent(ArticleEditMenu);
  };

  const setMainMenu = () => {
    resetToMainMenu();
  };

  return {
    setArticleEditMenu,
    setMainMenu,
    setCustomMenu: setMenuComponent,
  };
};
